import { field, date, children, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { RATE_LIST_SCHEMA } from '../schema';

export default class RateList extends Model {
    static table = RATE_LIST_SCHEMA;

    static associations = {
        rate_list_lines: { type: 'has_many', foreignKey: 'rate_list_id' },
        business: { type: 'belongs_to', key: 'business_id' },
    }

    @text('rate_list_name') rate_list_name;

    @date('created_at') created_at;
    @date('updated_at') updated_at;
    @date('validity') validity;

    @relation('business', 'business_id') business;
    @children('rate_list_lines') rate_list_lines;

};
